// Function helper untuk Meta Pixel tracking
const trackMetaEvent = (eventName, params = {}) => {
    if (window.fbq) {
        window.fbq('track', eventName, params);
    }
};

const trackMetaPageView = () => {
    if (window.fbq) {
        window.fbq('track', 'PageView');
    }
};

export { trackMetaEvent, trackMetaPageView };
